import template from './ticketHomeLoan.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    loan: '<',
    lenders: '<',
    countries: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdMedia,
      helperService,
      TicketLoanSecuritySplit,
      TicketLoanDetailsSplit,
      OwnershipType,
      PropertyType,
      TransactionType
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = null;
      ctrl.currentCurrency = null;
      ctrl.organizationCountry = '';
      ctrl.availablePropertyTypes = [];
      ctrl.availableOwnershipTypes = [];
      ctrl.availableTransactionTypes = [];
      ctrl.availableTermInYears = [];
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.currentCurrency = $rootScope.CurrentCurrency();
        ctrl.organizationCountry = helperService.getOrganizationCountry().name;
        ctrl.availablePropertyTypes = PropertyType.available();
        ctrl.availableOwnershipTypes = OwnershipType.available();
        ctrl.availableTransactionTypes = TransactionType.available();
        ctrl.availableTermInYears = helperService.getAvailableTermInYears({ isRegular: true });
        ctrl.loan = ctrl.loan || {};
        ctrl.lenders = ctrl.lenders || [];
        ctrl.countries = ctrl.countries || [];
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.isReady = true;
      };

      ctrl.ticketLoanSecuritySplitAdd = ($event) => {
        $event.stopPropagation();
        ctrl.loan.dealLoanSecuritySplit.push(TicketLoanSecuritySplit.blank());
      };

      ctrl.ticketLoanSecuritySplitDelete = (index) => {
        ctrl.loan.dealLoanSecuritySplit.splice(index, 1);
        ctrl.saveTicketHomeLoan();
      };

      ctrl.ticketLoanDetailsSplitAdd = ($event) => {
        $event.stopPropagation();
        ctrl.loan.details.dealLoanDetailsSplit.push(TicketLoanDetailsSplit.blank());
      };

      ctrl.ticketLoanDetailsSplitDelete = (index) => {
        ctrl.loan.details.dealLoanDetailsSplit.splice(index, 1);
        ctrl.saveTicketHomeLoan();
      };

      ctrl.clearSearchTerm = () => {
        ctrl.searchTerm = '';
      };

      ctrl.isLenderSelected = (lender) => {
        if (lender && ctrl.lenders.length) {
          const lS = ctrl.lenders.find((l) => l.abbr.toLowerCase() === lender);
          return lS !== undefined;
        }
        return true;
      };

      ctrl.totalHomeLoanFees = () => {
        let total = 0;
        Object.keys(ctrl.loan.fees).forEach((key) => {
          total += helperService.isNumber(ctrl.loan.fees[key], true);
        });
        return total;
      };

      ctrl.saveTicketHomeLoan = () => ctrl.onFinished({ loan: ctrl.loan });

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
